import React from 'react';
import { useSelector } from 'react-redux';
import NewMap from './new/map';
import ErrorMap from './error/map';
import CancelledMap from './cancelled/map';
import CompletedMap from './completed/map';
import { OrderEntity, OrderMissionEntity, OrderStatusEnum } from '@src/features/order/entities';
import { selectOrder } from '@src/features/order/pages/orders-page/redux';

const Maps: React.FC = () => {
  const order = useSelector(selectOrder);

  if (!order) return null;

  if (order.status === OrderStatusEnum.NEW) {
    return <NewMap order={order as OrderEntity} />;
  }

  if (order.status === OrderStatusEnum.ERROR) {
    return <ErrorMap order={order as OrderMissionEntity} />;
  }

  if (order.status === OrderStatusEnum.CANCELLED) {
    return <CancelledMap order={order as OrderMissionEntity} />;
  }

  if (order.status === OrderStatusEnum.COMPLETED) {
    return <CompletedMap order={order as OrderMissionEntity} />;
  }

  return null;
};

export default Maps;